import type { Permission } from '@jecks/shared';
import {
  BarChart3,
  Boxes,
  ClipboardList,
  FileText,
  LayoutDashboard,
  Mail,
  Megaphone,
  Package,
  Settings,
  ShoppingCart,
  Truck,
  Users,
  Wallet,
} from 'lucide-react';
import type { ComponentType } from 'react';

/**
 * Left navigation — one entry per module of PRD Section 5, in the same order.
 * `permission` drives both the menu and the route guard, so a hidden section is also
 * an unreachable URL (acceptance criterion 6).
 */
export interface NavItem {
  /** Stable key for realtime badge counters and saved views. */
  key: string;
  label: string;
  to: string;
  icon: ComponentType<{ className?: string }>;
  permission: Permission;
}

export const NAVIGATION: NavItem[] = [
  { key: "dashboard", label: 'Tableau de bord', to: '/', icon: LayoutDashboard, permission: 'reports.read' },
  { key: "orders", label: 'Commandes', to: '/orders', icon: ShoppingCart, permission: 'orders.read' },
  { key: "catalog", label: 'Catalogue', to: '/catalog/products', icon: Package, permission: 'catalog.read' },
  { key: "inventory", label: 'Stock', to: '/inventory', icon: Boxes, permission: 'inventory.read' },
  { key: "customers", label: 'Clients', to: '/customers', icon: Users, permission: 'customers.read' },
  { key: "delivery", label: 'Livraison', to: '/delivery', icon: Truck, permission: 'delivery.read' },
  { key: "promotions", label: 'Promotions', to: '/promotions', icon: Megaphone, permission: 'promotions.read' },
  { key: "finance", label: 'Finances', to: '/finance', icon: Wallet, permission: 'finance.read' },
  { key: "reports", label: 'Rapports', to: '/reports', icon: BarChart3, permission: 'reports.read' },
  { key: "content", label: 'Contenu', to: '/content', icon: FileText, permission: 'content.read' },
  { key: "marketing", label: 'Marketing', to: '/marketing', icon: Mail, permission: 'marketing.read' },
  { key: "audit", label: 'Journal', to: '/audit', icon: ClipboardList, permission: 'audit.read' },
  { key: "settings", label: 'Réglages', to: '/settings', icon: Settings, permission: 'settings.read' },
];
